import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import ListViewCpt from '@/components/list/ListViewCpt';
import PopSelect from '@/components/pop-select';
import { rqtPostListTradeInputPage } from '@/services/wms/trade';
import { rqtPostProductListForSelect } from '@/services/wms/product';
import cptCmn from '@/mixin/cpt-cmn';
export default {
  mixins: [cptCmn],
  components: {
    PageNavBackLayoutCpt,
    ListViewCpt,
    PopSelect
  },
  data() {
    return {
      btnLoading: false,
      searchForm: {
        chnName: undefined,
        productCode: null,
        tradeStatus: null,
        auditStatus: null
      },
      listRequest: rqtPostListTradeInputPage,
      codeResItems: [{
        title: '交易状态',
        dataIndex: 'tradeStatus',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'tradeStatus'
      }, {
        title: '审核状态',
        dataIndex: 'auditStatus',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'auditStatus'
      }],
      showPopup: false,
      searchItems: [{
        title: '产品',
        type: 'dropdown',
        name: 'productCode',
        request: rqtPostProductListForSelect,
        keyName: 'productCode',
        valueName: 'productName',
        paramName: 'param',
        selectedOptions: []
      }, {
        title: '交易状态',
        type: 'flatSelect',
        name: 'tradeStatus',
        mutiSelect: false,
        options: [],
        selectedOptions: []
      }, {
        title: '审核状态',
        type: 'flatSelect',
        name: 'auditStatus',
        mutiSelect: false,
        options: [],
        selectedOptions: []
      }]
    };
  },
  computed: {
    noCondition() {
      for (let selectItem of this.searchItems) {
        if (selectItem.selectedOptions.length > 0) {
          return false;
        }
      }
      return true;
    }
  },
  mounted() {
    this.initResCodeType(this.codeResItems).then(res => {
      for (let item of this.searchItems) {
        for (let codeItem of res) {
          if (item.name == codeItem.dataIndex) {
            item.options = codeItem.dataRes.map(e => {
              return {
                key: e.code,
                value: e.codeName
              };
            });
            break;
          }
        }
      }
    });
  },
  methods: {
    onSearch() {
      this.btnLoading = true;
      this.$refs['ListViewCpt'].initListData();
    },
    onListDataChange() {
      if (this.btnLoading) {
        this.btnLoading = false;
      }
    },
    showCondition() {
      this.showPopup = true;
    },
    handlePopSelectConfirm(searchItems) {
      for (let searchItem of searchItems) {
        this.searchForm[searchItem.name] = searchItem.selectedOptions[0];
      }
      this.$refs['ListViewCpt'].initListData();
      this.showPopup = false;
    }
  }
};